import { Fields } from '@measured/puck';
import PaddingComponent from '../../components/customComponents/PaddingComponent';

export type paddingSubProps = {
  top: string;
  bottom: string;
  left: string;
  right: string;
};
export type PaddingType = {
  paddingTop: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  paddingBottom: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  paddingLeft: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  paddingRight: {
    [key: string]: string;
    mobile: string;
    tablet: string;
    desktop: string;
  };
  deviceType: string;
};
export type PaddingProps = {
  padding: PaddingType;
};

export const paddingProps = {
  padding: {
    deviceType: 'desktop',
    paddingBottom: {
      desktop: '0',
      mobile: '0',
      tablet: '0',
    },
    paddingLeft: {
      desktop: '0',
      mobile: '0',
      tablet: '0',
    },
    paddingRight: {
      desktop: '0',
      mobile: '0',
      tablet: '0',
    },
    paddingTop: {
      desktop: '0',
      mobile: '0',
      tablet: '0',
    },
  },
};

export const paddingFields: Fields<PaddingProps> = {
  padding: {
    type: 'custom',
    label: 'Padding',
    render: ({ value, onChange }) => (
      <PaddingComponent value={value} onChange={onChange} title="Padding" />
    ),
  },
};
